import Alert from 'react-bootstrap/Alert';

function MessageBox(message) {
  return <Alert variant={message.variant || 'info'}>{message.children}</Alert>;
}

export default MessageBox;
